import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function LegalLayout({ title, updated, children, testId }) {
  return (
    <div data-testid={testId} className="min-h-screen bg-[#05050A] text-slate-100 font-body">
      <div className="pointer-events-none fixed inset-0 -z-10 opacity-60"
        style={{
          background:
            "radial-gradient(60% 40% at 20% 10%, rgba(147,51,234,0.15) 0%, transparent 60%), radial-gradient(50% 40% at 80% 90%, rgba(59,130,246,0.13) 0%, transparent 60%)",
        }}
      />
      <div className="max-w-3xl mx-auto px-6 md:px-10 py-16 md:py-24">
        <Link to="/" className="inline-flex items-center gap-2 text-slate-400 hover:text-white transition text-sm mb-8" data-testid="legal-back">
          <ArrowLeft size={16} /> Torna alla home
        </Link>
        <div className="flex items-center gap-3 mb-4">
          <img src="/assets/logo.png" alt="Social Whale" className="h-9 w-9 object-contain drop-shadow-[0_0_18px_rgba(147,51,234,0.5)]" />
          <span className="font-display font-bold text-lg text-white">Social<span className="text-gradient">Whale</span></span>
        </div>
        <h1 className="font-display text-4xl md:text-5xl text-white tracking-tighter leading-[1.05]">{title}</h1>
        {updated && <div className="mt-3 text-xs uppercase tracking-widest text-slate-500">Ultimo aggiornamento: {updated}</div>}
        <article className="prose prose-invert prose-slate max-w-none mt-10 text-slate-300 leading-relaxed [&_h2]:font-display [&_h2]:text-white [&_h2]:text-2xl [&_h2]:mt-10 [&_h2]:mb-4 [&_h3]:text-white [&_h3]:mt-8 [&_h3]:mb-3 [&_a]:text-purple-300 [&_a:hover]:text-white [&_ul]:list-disc [&_ul]:pl-6 [&_ol]:list-decimal [&_ol]:pl-6 [&_p]:my-4 [&_li]:my-1.5">
          {children}
        </article>
      </div>
    </div>
  );
}
